import { render, staticRenderFns } from "./SubmitProposalMessageDetails.vue?vue&type=template&id=4e619e70&"
import script from "./SubmitProposalMessageDetails.vue?vue&type=script&lang=js&"
export * from "./SubmitProposalMessageDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports